export const INVALID_CREDENTIALS = 'invalid_credentials';
export const ACCOUNT_NOT_CONFIRMED = 'account_not_confirmed';
export const INVALID_RHE_SSO_ID = 'invalid_rhe_sso_id';
export const ACCOUNT_DEACTIVATED = 'account_deactivated';
export const GENERIC_ERROR = 'generic_error';
